import { NgModule } from '@angular/core';
import { RouterModule, Routes, UrlSegment } from '@angular/router';
import { QuicklinkModule, QuicklinkStrategy } from 'ngx-quicklink';

import { environment } from '../environments/environment';

// Category and CMS routes are added dynamically in ./app.initializers.ts.

export function matchProducts(url: UrlSegment[]) {
    const isMatch = url.length == 1 && new RegExp(environment.productUrlRegex).test(url[0].path);
    return isMatch ? { consumed: url, posParams: { productUrl: url[0] } } : null;
}

const routes: Routes = [
    {
        path: '',
        loadChildren: () => import('./cms/pages/cms-homepage/cms-homepage.module').then((m) => m.HomePageModule),
    },
    {
        path: 'blog',
        loadChildren: () => import('./cms/blog/blog.module').then((m) => m.BlogModule),
    },
    {
        path: 'About-Us',
        loadChildren: () => import('./cms/pages/cms-about-us/cms-about-us.module').then((m) => m.AboutUsModule),
    },
    {
        path: 'Applications-Forms',
        loadChildren: () => import('./cms/pages/cms-applications-forms/cms-application.module').then((m) => m.ApplicationFormsModule),
    },
    {
        path: 'B2B-Services',
        loadChildren: () => import('./cms/pages/cms-b2b-service/cms-b2b-service.module').then((m) => m.CmsB2bServiceModule),
    },
    {
        path: 'category',
        loadChildren: () => import('./category/category.module').then((m) => m.CategoryModule),
    },
    {
        path: 'Contact-Us',
        loadChildren: () => import('./cms/pages/cms-contact-us/cms-contact-us.module').then((m) => m.ContactUsModule),
    },
    {
        path: 'policy',
        loadChildren: () => import('./cms/pages/cms-policies/cms-policies.module').then((m) => m.PoliciesModule),
    },
    {
        path: 'RMA-Request',
        loadChildren: () => import('./cms/pages/cms-rma-request/cms-rma-request.module').then((m) => m.RMARequestModule),
    },
    {
        path: 'Service-Support',
        loadChildren: () => import('./cms/pages/cms-service-support/cms-service-support.module').then((m) => m.ServiceSupportModule),
    },
    {
        path: 'account',
        loadChildren: () => import('./account/account.module').then((m) => m.AccountModule),
    },
    {
        path: 'checkout',
        loadChildren: () => import('./checkout/checkout.module').then((m) => m.CheckoutModule),
    },
    {
        path: 'privacy',
        loadChildren: () => import('./privacy/privacy.module').then((m) => m.PrivacyModule),
    },
    {
        path: 'cookies',
        loadChildren: () => import('./privacy/cookies/cookies.module').then((m) => m.CookiesModule),
    },
    {
        matcher: matchProducts,
        loadChildren: () => import('./product/product.module').then((m) => m.ProductModule),
    },
    {
        path: '404',
        loadChildren: () => import('./not-found/not-found.module').then((m) => m.NotFoundModule),
    },
    {
        path: '**',
        loadChildren: () => import('./not-found/not-found.module').then((m) => m.NotFoundModule),
    },
];
@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            initialNavigation: 'enabledNonBlocking',
            scrollPositionRestoration: 'disabled',
            preloadingStrategy: QuicklinkStrategy,
            errorHandler: (error: any) => {
                console.error('Router error:', error);
                // Don't rethrow to prevent app crashes
            },
        }),
        QuicklinkModule,
    ],
    exports: [RouterModule, QuicklinkModule],
})
export class AppRoutingModule {}
